import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

// One row of a credential that is shown once and never again: the value in monospace with
// a button that puts it on the clipboard. Both places that hand over a password use this —
// the reset dialog and the employee-login dialog — because selecting a ten-character string
// out of a line of prose by hand is where somebody drops a character and blames the system.
export default function CopyableSecret({ label, value, testid }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      // Refused outside a secure context and by some browser policies. Saying so is
      // better than a button that animates as though it worked.
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error(`Could not reach the clipboard — select the ${label.toLowerCase()} and copy it by hand`);
    }
  };

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <span className="text-muted-foreground">{label}:</span>{" "}
        <span className="break-all" data-testid={testid}>{value}</span>
      </div>
      <Button variant="ghost" size="sm" onClick={copy} className="shrink-0 h-7 px-2"
              aria-label={`Copy ${label.toLowerCase()}`} data-testid={testid && `${testid}-copy`}>
        {copied
          ? <><Check className="w-3.5 h-3.5 mr-1" /> Copied</>
          : <><Copy className="w-3.5 h-3.5 mr-1" /> Copy</>}
      </Button>
    </div>
  );
}
